/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_ProInputs */

const en_mobile_pro = /** @type {(inputs: Mobile_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRO`)
};

const es_mobile_pro = /** @type {(inputs: Mobile_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRO`)
};

/**
* | output |
* | --- |
* | "PRO" |
*
* @param {Mobile_ProInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_pro = /** @type {((inputs?: Mobile_ProInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_ProInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_pro(inputs)
	return en_mobile_pro(inputs)
});